import { render } from "./side-panel.vue?vue&type=template&id=3d8a6744&lang=pug"
import script from "./side-panel.vue?vue&type=script&lang=js"
export * from "./side-panel.vue?vue&type=script&lang=js"

import "./side-panel.vue?vue&type=style&index=0&id=3d8a6744&lang=scss"

import exportComponent from "C:\\m-tech\\WMExtranet2.0\\WebUI\\WiseApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__